import { IRequesterInfo } from '../../../base/models'
import { DirectResponseProxy } from '../../../base/proxy/clientProxy'

export interface IApproveComPayAgreementRequest {
  FileUrl: string
}

export class CompayPopupApprovalApi extends DirectResponseProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'compay-payment/approve-credit-agreement',
      requesterInfo,
    })
  }

  public async creditContractApproval(request: IApproveComPayAgreementRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
